/* DESIGNSPOT – hlavička (redesign 10/2026) */
(function () {
  var root = document.getElementById('DsHeader');
  if (!root) return;
  var sec = root.closest('.shopify-section') || root;
  var html = document.documentElement;
  var desk = window.matchMedia('(min-width: 990px)');

  /* ---------- megamenu: rozdělení skupin do sloupců (nejkratší sloupec) ---------- */
  root.querySelectorAll('.dsh-mm__cats[data-cols]').forEach(function (box) {
    var n = parseInt(box.getAttribute('data-cols'), 10) || 3;
    var grps = Array.prototype.slice.call(box.children);
    var cols = [], h = [];
    for (var i = 0; i < n; i++) { var c = document.createElement('div'); c.className = 'dsh-mm__col'; cols.push(c); h.push(0); }
    grps.forEach(function (g) {
      var k = h.indexOf(Math.min.apply(null, h));
      cols[k].appendChild(g);
      h[k] += g.querySelectorAll('li').length + 2;
    });
    box.innerHTML = '';
    cols.forEach(function (c) { box.appendChild(c); });
  });
  // odkaz „Vše z …“ pod první sloupec
  root.querySelectorAll('.dsh-mm').forEach(function (mm) {
    var foot = mm.querySelector('.dsh-mm__foot'); if (!foot) return;
    var as = foot.querySelectorAll('.dsh-all'); var col = mm.querySelector('.dsh-mm__col') || mm.querySelector('.dsh-mm__cats--flat');
    if (as.length && col) { as.forEach(function (a) { col.appendChild(a); }); foot.remove(); }
  });

  /* ---------- megamenu: otevírání se zpožděním (Baymard 300–500 ms) ---------- */
  var openId = null, tOpen = null, tClose = null;
  var noMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var triggers = root.querySelectorAll('[data-mm]');
  function show(id) {
    clearTimeout(tClose);
    if (openId === id) return;
    var fresh = !openId; // animovat jen první otevření, při přejíždění mezi položkami se obsah jen vymění
    hide(true);
    var p = document.getElementById(id); if (!p) return;
    p.classList.remove('is-anim');
    p.hidden = false; openId = id;
    if (fresh && !noMotion.matches) { void p.offsetWidth; p.classList.add('is-anim'); }
    var a = root.querySelector('[data-mm="' + id + '"]');
    if (a) { a.classList.add('is-open'); a.setAttribute('aria-expanded', 'true'); }
  }
  function hide(now) {
    if (!openId) return;
    var p = document.getElementById(openId); if (p) p.hidden = true;
    var a = root.querySelector('[data-mm="' + openId + '"]');
    if (a) { a.classList.remove('is-open'); a.setAttribute('aria-expanded', 'false'); }
    openId = null;
  }
  triggers.forEach(function (a) {
    var id = a.getAttribute('data-mm');
    a.addEventListener('mouseenter', function () {
      if (!desk.matches) return;
      clearTimeout(tOpen); clearTimeout(tClose);
      tOpen = setTimeout(function () { show(id); }, openId ? 150 : 300);
    });
    a.addEventListener('mouseleave', function () { clearTimeout(tOpen); });
    a.addEventListener('focus', function () { if (desk.matches) show(id); });
    a.addEventListener('click', function (e) {
      // dotykové zařízení na šířce počítače: první klepnutí otevře menu
      if (desk.matches && window.matchMedia('(hover: none)').matches && openId !== id) { e.preventDefault(); show(id); }
    });
  });
  // položka bez podmenu (Novinky, Vánoce): otevřené megamenu po chvíli zavřít
  root.querySelectorAll('.dsh-nav__a:not([data-mm])').forEach(function (a) {
    a.addEventListener('mouseenter', function () {
      if (!desk.matches) return;
      clearTimeout(tOpen);
      tOpen = setTimeout(function () { hide(); }, 150);
    });
    a.addEventListener('mouseleave', function () { clearTimeout(tOpen); });
    a.addEventListener('focus', function () { hide(); });
  });
  var bar = root.querySelector('.dsh-bar');
  bar.addEventListener('mouseleave', function () { clearTimeout(tOpen); tClose = setTimeout(function () { hide(); }, 250); });
  bar.addEventListener('mouseenter', function () { clearTimeout(tClose); });
  root.querySelectorAll('.dsh-mm').forEach(function (p) {
    p.addEventListener('mouseenter', function () { clearTimeout(tClose); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { hide(); closeSearch(); closeDrawer(); } });
  document.addEventListener('click', function (e) { if (openId && !bar.contains(e.target)) hide(); });
  root.querySelectorAll('.dsh-mm').forEach(function (p) {
    p.addEventListener('focusout', function (e) { if (!bar.contains(e.relatedTarget)) hide(); });
  });

  /* ---------- sticky: stín pod hlavním řádkem po odscrollování ---------- */
  var ticking = false;
  function onScroll() { sec.classList.toggle('is-stuck', window.scrollY > 40); ticking = false; }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();

  /* ---------- vyhledávání s napovídáním ---------- */
  var sBox = document.getElementById('DshSearch');
  var sIn = sBox.querySelector('.dsh-search__in');
  var res = sBox.querySelector('[data-dsh-res]');
  var psUrl = root.getAttribute('data-ps-url');
  var searchUrl = root.getAttribute('data-search-url');
  var tS = null, ctrl = null, sel = -1;
  function openSearch() {
    closeDrawer(); hide();
    sBox.hidden = false; html.classList.add('dsh-search-open');
    root.querySelectorAll('[data-dsh-search]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { sIn.focus(); sIn.select(); }, 30);
  }
  function closeSearch() {
    if (sBox.hidden) return;
    sBox.hidden = true; html.classList.remove('dsh-search-open');
    root.querySelectorAll('[data-dsh-search]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  root.querySelectorAll('[data-dsh-search]').forEach(function (b) { b.addEventListener('click', openSearch); });
  sBox.querySelector('[data-dsh-search-close]').addEventListener('click', closeSearch);
  document.addEventListener('click', function (e) {
    if (!sBox.hidden && !sBox.contains(e.target) && !e.target.closest('[data-dsh-search]')) closeSearch();
  });

  var lang = (html.getAttribute('lang') || 'cs').slice(0, 2);
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CZK';
  var fmt;
  try { fmt = new Intl.NumberFormat(lang === 'sk' ? 'sk-SK' : 'cs-CZ', { style: 'currency', currency: cur, minimumFractionDigits: cur === 'CZK' ? 0 : 2, maximumFractionDigits: cur === 'CZK' ? 0 : 2 }); } catch (e) { fmt = null; }
  function money(v) { var n = parseFloat(v); if (isNaN(n)) return ''; return fmt ? fmt.format(n) : n + ' ' + cur; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var allow = {};
  (root.getAttribute('data-allow') || '').split('|').forEach(function (p) { if (p) allow[p] = 1; });
  function path(u) { try { return decodeURI(new URL(u, location.origin).pathname); } catch (e) { return u; } }
  function img(u) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }

  function render(q, r) {
    var t = res.dataset;
    var left = '';
    (r.queries || []).slice(0, 5).forEach(function (x) { left += '<li><a href="' + esc(x.url) + '">' + (x.styled_text || esc(x.text)) + '</a></li>'; });
    (r.collections || []).filter(function (x) { return allow[path(x.url)]; }).slice(0, 3).forEach(function (x) { left += '<li><a href="' + esc(x.url) + '">' + esc(x.title) + '</a></li>'; });
    (r.pages || []).slice(0, 2).forEach(function (x) { left += '<li><a href="' + esc(x.url) + '">' + esc(x.title) + '</a></li>'; });
    var prods = '';
    (r.products || []).slice(0, 6).forEach(function (p) {
      prods += '<a class="dsh-res__p" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(img(p.image)) + '" alt="" loading="lazy">' : '') +
        '<div><span>' + esc(p.title) + '</span><small>' + esc(p.vendor) + '</small><em>' + money(p.price) + '</em></div></a>';
    });
    if (!left && !prods) { res.innerHTML = ''; return; }
    res.innerHTML =
      (left ? '<div><span class="dsh-lab">' + esc(t.tSuggest) + '</span><ul class="dsh-res__list">' + left + '</ul></div>' : '<div></div>') +
      (prods ? '<div><span class="dsh-lab">' + esc(t.tProducts) + '</span><div class="dsh-res__prod">' + prods + '</div></div>' : '') +
      '<div class="dsh-res__all"><a class="dsh-all" href="' + esc(searchUrl) + '?q=' + encodeURIComponent(q) + '&type=product">' + esc(t.tAll) + '</a></div>';
    sel = -1;
  }
  function fetchRes() {
    var q = sIn.value.trim();
    if (q.length < 2) { res.innerHTML = ''; return; }
    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    var url = psUrl + '.json?q=' + encodeURIComponent(q) +
      '&resources[type]=query,product,collection,page&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); })
      .then(function (d) { if (sIn.value.trim() === q) render(q, (d.resources && d.resources.results) || {}); })
      .catch(function () {});
  }
  sIn.addEventListener('input', function () { clearTimeout(tS); tS = setTimeout(fetchRes, 200); });
  sIn.addEventListener('keydown', function (e) {
    var items = res.querySelectorAll('.dsh-res__list a, .dsh-res__p');
    if (!items.length || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter')) return;
    if (e.key === 'Enter') { if (sel > -1) { e.preventDefault(); items[sel].click(); } return; }
    e.preventDefault();
    if (sel > -1) items[sel].classList.remove('is-sel');
    sel = e.key === 'ArrowDown' ? (sel + 1) % items.length : (sel <= 0 ? items.length - 1 : sel - 1);
    items[sel].classList.add('is-sel');
    var l = items[sel].querySelector('span');
    if (items[sel].closest('.dsh-res__list')) sIn.value = items[sel].textContent;
    else if (l) { /* produkt – text v poli nechat */ }
  });

  /* ---------- mobilní menu (drill-down) ---------- */
  var drawer = document.getElementById('DshDrawer');
  var menuBtn = root.querySelector('[data-dsh-drawer]');
  var tPanel = null, tDrawer = null;
  function panels() { return drawer.querySelectorAll('.dsh-panel'); }
  function panelNow(name) {
    panels().forEach(function (p) { var on = p.getAttribute('data-panel') === name; p.hidden = !on; p.classList.remove('is-enter', 'is-leave'); if (on) p.scrollTop = 0; });
    drawer.scrollLeft = 0;
  }
  // dir: 'in' = další úroveň přijede zprava, 'out' = aktuální úroveň odjede doprava (320 ms)
  function panel(name, dir) {
    clearTimeout(tPanel);
    var cur = drawer.querySelector('.dsh-panel:not([hidden])');
    var next = drawer.querySelector('.dsh-panel[data-panel="' + name + '"]');
    if (!dir || !cur || !next || cur === next || noMotion.matches) { panelNow(name); return; }
    panels().forEach(function (p) { p.classList.remove('is-enter', 'is-leave'); });
    next.hidden = false; next.scrollTop = 0;
    if (dir === 'in') { void next.offsetWidth; next.classList.add('is-enter'); }
    else { void cur.offsetWidth; cur.classList.add('is-leave'); }
    tPanel = setTimeout(function () { panelNow(name); }, 330);
  }
  function openDrawer() {
    clearTimeout(tDrawer);
    closeSearch(); panelNow('root');
    drawer.classList.remove('is-in', 'is-closing');
    drawer.hidden = false; html.classList.add('dsh-locked');
    if (noMotion.matches) drawer.classList.add('is-in');
    else { void drawer.offsetWidth; drawer.classList.add('is-in'); }
    menuBtn.setAttribute('aria-expanded', 'true');
    var f = drawer.querySelector('[data-dsh-drawer-close]'); if (f) f.focus({ preventScroll: true });
  }
  function closeDrawer() {
    if (drawer.hidden) return;
    menuBtn.setAttribute('aria-expanded', 'false');
    html.classList.remove('dsh-locked');
    var done = function () { drawer.hidden = true; drawer.classList.remove('is-in', 'is-closing'); };
    if (noMotion.matches) { done(); return; }
    drawer.classList.add('is-closing'); drawer.classList.remove('is-in');
    clearTimeout(tDrawer); tDrawer = setTimeout(done, 270);
  }
  menuBtn.addEventListener('click', openDrawer);
  drawer.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { panel(o.getAttribute('data-open'), 'in'); var b = drawer.querySelector('[data-panel="' + o.getAttribute('data-open') + '"] [data-back]'); if (b) setTimeout(function () { b.focus({ preventScroll: true }); }, noMotion.matches ? 0 : 330); return; }
    if (e.target.closest('[data-back]')) { panel('root', 'out'); return; }
    if (e.target.closest('[data-dsh-drawer-close]')) { closeDrawer(); }
  });
  desk.addEventListener && desk.addEventListener('change', function () { if (desk.matches) closeDrawer(); else hide(); });
})();
